import { type FeatureModule } from '@store/features/types';

/**
 * Subscriptions feature module definition
 *
 * This is an API-only feature that manages subscription bundles, cart, and checkout.
 * It uses RTK Query for all data fetching and caching.
 */
export const subscriptionsFeature: FeatureModule = {
  id: 'subscriptions',
  name: 'Subscriptions',

  dependencies: [],

  // No reducers needed - this is an API-only feature
  reducers: {},

  // No middleware needed - API middleware is registered globally
  middleware: [],

  // No persistence needed for this API-only feature
  persistence: {
    enabled: false,
  },

  // No sync needed for this API-only feature
  sync: {
    enabled: false,
  },

  setup: _store => {
    // Feature initialization logic if needed
  },

  cleanup: _store => {
    // Feature cleanup logic if needed
  },
};
